import BottomFab from "@memorang/ui/src/components/BottomFab";
import Box from "@memorang/ui/src/components/Box";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import StudyPackView from "@memorang/ui/src/components/StudyPackApplet/StudyPackView";
import type {
	Distribution,
	FontSchemaType,
	QuickActionsChipType,
} from "@memorang/ui/src/types";
import { useDevice } from "@memorang/ui/src/useDevice";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import CustomNavigationBar from "../CustomAppbar";
import type { CustomNavigationBarProps } from "../CustomAppbar/types";
import type { Stat } from "../RowStats";
import type { SectionTag } from "./TagsSectionList";

const StudyPackApplet = ({
	distribution,
	productTitle,
	productImage,
	sectionTags,
	handleNavigateToIAP,
	handleQuickActionPress,
	bottomFab,
	stats,
	actionChips,
	handleClickListItem,
	appFont,
	customNavigationBarProps,
}: {
	stats: Stat[];
	distribution: Distribution;
	productTitle: string;
	productImage: string;
	sectionTags: SectionTag[];
	handleNavigateToIAP: () => void;
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	bottomFab: {
		icon: string;
		label: string;
		onPress: () => void;
	};
	actionChips: QuickActionsChipType[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
	handleFeedbackNavigation: (toggleShowFeedbackDialog: () => void) => void;
	customNavigationBarProps: CustomNavigationBarProps;
}) => {
	const inset = useSafeAreaInsets();

	const { isMobile } = useDevice();
	const isWeb = Platform.OS === "web";
	const Wrapper = isWeb ? ScrollContainer : Box;

	return (
		<>
			<CustomNavigationBar role="banner" {...customNavigationBarProps} />

			<Wrapper
				style={{
					flexGrow: 1,
					paddingHorizontal: isMobile ? 0 : 16,
				}}
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				<StudyPackView
					distribution={distribution}
					productTitle={productTitle}
					productImage={productImage}
					actionChips={actionChips}
					stats={stats}
					sectionTags={sectionTags}
					handleNavigateToIAP={handleNavigateToIAP}
					handleQuickActionPress={handleQuickActionPress}
					handleClickListItem={handleClickListItem}
					appFont={appFont}
				/>

				{isMobile && (
					<BottomFab
						icon={bottomFab.icon}
						bottom={inset.bottom}
						label={bottomFab.label}
						onPress={bottomFab.onPress}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default StudyPackApplet;
